import React, { FC } from 'react';
import { capitalize } from 'lodash';

import { Trans, useTranslation } from 'app/lang';
import { getUniversalEnv } from 'app/lib/get-universal-env';
import { getBrandName } from 'app/packages/brand';

import { InstructionImage } from '../../components/InstructionImage';

import dictionary from './IOSInstruction.dictionary.json';

import styles from './IOSInstruction.module.scss';

export const IOSInstruction: FC = () => {
  const { t } = useTranslation();
  const mobileAppLink = getUniversalEnv('MOBILE_WEB_APP_URL');

  return (
    <ul className={styles.root}>
      <li>
        <InstructionImage fileName="ios_step_1"
                          position="start" />
        <span className={styles.itemTitle}>
          <Trans data={dictionary.step1}
                 components={{
                   a: (
                     <a data-ga-event="qr-openPWA"
                        href={mobileAppLink} />
                   ),
                 }} />
        </span>
      </li>
      <li>
        <InstructionImage fileName="ios_step_2" />
        <span className={styles.itemTitle}>
          {t(dictionary.step2)}
        </span>
      </li>
      <li>
        <InstructionImage fileName="installation_completed" />
        <span className={styles.itemTitle}>
          {t(dictionary.step3, { brand: capitalize(getBrandName()) })}
        </span>
      </li>
    </ul>
  );
};
